import {createStyles, Theme} from "@material-ui/core";
import {primaryColor, styleColors} from "src/main.style";

export const TodoButtonStyle = (theme: Theme) => createStyles({
  styledAddIcon: {
    fontSize: '45px',
  },
  fab: {
    zIndex: 3,
    position: 'fixed',
    bottom: 100,
    right: 20,
    transition: 'all 0.2s',
    overflow: 'auto',
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    borderRadius: 31,
    color: '#FFFFFF',
    width: '62px',
    cursor: 'pointer',
    height: '62px',
    fontSize: '45px',
    lineHeight: '45px',
    userSelect: 'none',
    WebkitUserSelect: 'none',
    justifyContent: 'center',
    boxShadow: `0px 3px 30px ${styleColors.fabShadow}`,
    backgroundColor: primaryColor,
    '&:hover': {
      backgroundColor: primaryColor,
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/todo/TodoButton.style.ts